document.addEventListener("DOMContentLoaded", () => {
  const titles = document.querySelectorAll('.js-aa-accordion-title');

  if (titles.length > 0) {
    // 最初のタイトルとコンテンツを開いた状態にする
    let firstTitle = titles[0];
    let firstContent = firstTitle.nextElementSibling;
    firstTitle.classList.add('is-active');
    firstTitle.setAttribute('aria-expanded', 'true');
    if (firstContent) firstContent.classList.add('is-open');
  }

  const toggle = (titleEach, content) => {
    const isOpen = titleEach.classList.toggle('is-active');
    if (content) content.classList.toggle('is-open');
    titleEach.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  };

  for (let i = 0; i < titles.length; i++) {
    let titleEach = titles[i];
    let content = titleEach.nextElementSibling;

    titleEach.addEventListener('click', () => toggle(titleEach, content));

    // キーボード操作（Enter / Space）に対応
    titleEach.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        toggle(titleEach, content);
      }
    });
  }
});
